import { LocationType } from './location-type';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@morningstar/shared/environment';
import { catchError } from 'rxjs/operators';
import { GenericErrorHandler } from '@morningstar/shared/base/error-handler';
import { ILocation } from './location';

@Injectable()
export class LocationsService {

  constructor(private httpClient: HttpClient) { }

  get(includeAll: boolean, type: LocationType = LocationType.Standard): Observable<ILocation[]> {
    // tslint:disable-next-line:max-line-length
    let endpoint = '';

    switch (type) {
      case LocationType.CCWS:
        endpoint = environment.api.locations.ccws;
        break;
      case LocationType.Scheduler:
        endpoint = environment.api.locations.scheduler;
        break;
      default:
        endpoint = environment.api.locations.standard;
        break;
    }

    return this.httpClient.get<ILocation[]>(`${environment.spaceGeekUrl + endpoint}`.replace('{includeAll}', includeAll.toString()))
                          .pipe(catchError(GenericErrorHandler.handleError<ILocation[]>('getLocationStandard')));
  }
}
